<template>
  <div>
    <v-overlay v-if="loading" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div v-else>
      <v-container box-container>
        <div class="mb-4">
          <v-breadcrumbs :items="paths" divider=">">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item
                :href="item.href"
                class="simple_text grey_8--text"
                >{{ item.text }}</v-breadcrumbs-item
              >
            </template>
          </v-breadcrumbs>
          <v-btn text small @click="goBack" class="ml-2">
            <v-icon>mdi-arrow-left</v-icon>
            <span class="text-none simple_text grey_8--text"
              >Retourner aux recherches</span
            >
          </v-btn>
        </div>
      </v-container>

      <div class="image-displayer">
        <Carousel :images="images" height="400" />
        <!-- <v-img
          max-height="300px"
          v-for="(img, i) in images"
          :key="i"
          link
          :src="img"
          aspect-ratio="1.4"
          @click="openImg(img)"
        ></v-img>-->

        <v-btn
          absolute
          right
          class="email-btn ma-2 mt-5"
          :href="generateMailtoShare"
        >
          <span class="text-none simple_text grey_8--text"
            >Partager par email</span
          >
          <Icon class="btn-icon" type="share-alt" />
        </v-btn>
        <v-btn absolute right bottom class="like-btn ma-2" @click="like">
          <span v-if="isLiked" class="text-none simple_text grey_8--text"
            >Enregistré</span
          >
          <span v-else class="text-none simple_text grey_8--text"
            >Enregistrer</span
          >
          <Icon
            class="btn-icon"
            style="color: red"
            :theme="isLiked ? 'filled' : 'outlined'"
            type="heart"
          />
        </v-btn>
        <!-- <v-btn class="text-none" absolute bottom right color="grey" :v-if="images.length > 3">Voir toutes les images</v-btn> -->
      </div>
      <v-container box-container>
        <div class="body">
          <v-row>
            <v-col xs="12" sm="12" md="6" lg="6" xl="6">
              <!-- informations -->
              <div class="article">
                <div>
                  <span class="title" v-if="data.name"
                    >{{ data.name }} / {{ data.localisation }}</span
                  >
                  <span class="subtitle" v-if="data.surface"
                    >{{ parseInt(data.surface).toLocaleString() }} m²</span
                  >
                  <div class="dark_blue--text" v-if="data.loyer_mensuel">
                    <span class="subtitle"
                      >{{ parseInt(data.loyer_mensuel).toLocaleString() }}€ /
                      mois</span
                    >
                    <span class="subtitle" v-if="data.loyer_journalier">
                      soit
                      {{ parseInt(data.loyer_journalier).toLocaleString() }} € /
                      jour
                    </span>
                  </div>

                  <span class="subtitle dark_blue--text" v-if="data.loyer_m2"
                    >{{ parseInt(data.loyer_m2).toLocaleString() }}€ / m2 / an
                    HT CC</span
                  >
                </div>

                <div class="buttons">
                  <v-btn
                    text
                    class="button contact-button pt-1"
                    :href="generateMailtoContact"
                  >
                    <span>Prendre contact pour ce bien</span>
                    <Icon class="btn-icon" type="mail" />
                  </v-btn>
                  <v-btn text class="button contrat-button" @click="download">
                    Télécharger le projet de contrat
                    <Icon class="btn-icon" type="download" />
                  </v-btn>
                </div>
              </div>
              <div class="article" v-if="data.position">
                <span class="simple_text bold dark_grey--text pb-2"
                  >Localisation</span
                >
                <div class="map-container">
                  <GMap
                    :latitude="data.position.latitude"
                    :longitude="data.position.longitude"
                  />
                </div>
              </div>
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="6" xl="6">
              <div class="box-article">
                <span class="simple_text bold dark_grey--text"
                  >Description</span
                >
                <v-divider />
                <span
                  v-if="data.description"
                  class="simple_text grey_8--text"
                  >{{ data.description }}</span
                >
              </div>
              <div class="box-article">
                <span class="simple_text bold dark_grey--text"
                  >Usages possibles</span
                >
                <v-divider />
                <div v-for="(usage, i) in getUsages" :key="i" link>
                  <div class="usage">
                    <span class="simple_text grey_8--text">
                      {{ getUsageName(usage) }}
                    </span>
                    <span class="regular_text grey_7--text">
                      {{ getUsageDescription(usage) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="box-article">
                <span class="simple_text bold dark_grey--text"
                  >Contraintes particulières</span
                >
                <v-divider />
                <span
                  v-if="data.contraintes"
                  class="simple_text grey_8--text"
                  >{{ data.contraintes }}</span
                >
              </div>
              <div class="box-article">
                <span class="simple_text bold dark_grey--text"
                  >Type de contrats possible</span
                >
                <v-divider />
                <span v-if="data.contrat" class="simple_text grey_8--text">
                  {{ data.contrat }}
                </span>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import { Icon } from "ant-design-vue";
import GMap from "@/components/GMap";
import { mapGetters, mapActions } from "vuex";
import Carousel from "@/components/Carousel";
import downloadContract from "@/services/contract";
import { NOT_LOGGED_IN, LIKED } from "@/utils/snackbar_constants";
import { share_mail, contact_mail } from "@/services/mail";
import { like } from "@/services/like";
import { getImages } from "@/services/image";
import { getBien } from "@/services/biens";

export default {
  name: "ContentView",
  props: ["id"],
  components: {
    Icon,
    GMap,
    Carousel
  },
  data() {
    return {
      loading: true,
      data: null,
      images: [],
      cmptr: 0,
      paths: [
        {
          text: "Acceuil",
          disabled: false,
          href: "/#/"
        },
        {
          text: "Recherche",
          disabled: false,
          href: "/#/search"
        },
        {
          text: "",
          disabled: true,
          href: "breadcrumbs_link_2"
        }
      ]
    };
  },
  methods: {
    ...mapActions({
      actlike: "likeModule/like",
      fetchData: "dataModule/fetchData",
      notify: "notificationModule/notify"
    }),
    openImg(arg) {
      window.open(arg);
    },
    getUsageName(id) {
      var data = this.getData.usage.data;
      var res = "";
      data.forEach(element => {
        if (element.id == id) {
          res = element.name;
        }
      });
      return res;
    },
    getUsageDescription(id) {
      var data = this.getData.usage.data;
      var res = "";
      data.forEach(element => {
        if (element.id == id) {
          res = element.description;
        }
      });
      return res;
    },
    is_usage(item) {
      let res = item.includes("usage");
      return res;
    },
    like() {
      if (!this.haveUser) {
        this.notify(NOT_LOGGED_IN);
        //this.redirect("Inscription");
        return;
      }
      like(this.id, this.getLikes, () => {
        this.notify(LIKED);
      });
    },
    goBack() {
      this.$router.push({ path: "/search" });
    },
    displayLink() {},
    download() {
      if (!this.haveUser) {
        this.notify(NOT_LOGGED_IN);
        //this.redirect("Inscription");
        return;
      }
      downloadContract(
        this.id,
        `contrat_${this.id}_${this.data.name}_${this.data.localisation}.pdf`
      );
    },
    async geocoding(address) {
      return new Promise((resolve, reject) => {
        fetch(
          "https://us-central1-foncierpublic-ecd11.cloudfunctions.net/longLatMaps",
          { method: "POST", body: JSON.stringify({ address: address }) }
        )
          .then(res => res.json())
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  computed: {
    ...mapGetters({
      haveUser: "userModule/haveUser",
      getData: "dataModule/getData",
      getLikes: "likeModule/getLikes"
    }),
    isLiked() {
      let arr = this.getLikes;
      let ret = false;
      arr.forEach(e => {
        if (e === this.id) {
          ret = true;
        }
      });
      return ret;
    },
    getUsages() {
      if (this.data != null && this.data.properties != null) {
        return this.data.properties.filter(e => this.is_usage(e));
      }
      return [];
    },
    generateMailtoShare() {
      return share_mail(this.id);
    },
    generateMailtoContact() {
      return contact_mail(this.id);
    }
  },
  beforeMount() {
    getBien(this.id, data => {
      this.data = data;
      if (!data.position && data.localisation) {
        this.geocoding(data.localisation).then(r => {
          if (
            r.satus == "SUCCESS" &&
            r.data &&
            r.data.results &&
            r.data.results[0] &&
            r.data.results[0].geometry &&
            r.data.results[0].geometry.location
          ) {
            let location = r.data.results[0].geometry.location;

            this.data.position = {
              latitude: location.lat,
              longitude: location.lng
            };
          }
        });
      }
      this.paths[2].text = this.data.name + " / " + this.data.localisation;
      getImages(this.id, images => {
        this.images = images;
        this.loading = false;
      });
    });
  }
};
</script>

<style scoped>
.top-navigation-div {
  background: #ffffff;

  border: 1px solid #bcccdc;
  box-sizing: border-box;
  border-radius: 14px;
}

.map-container {
  width: 100%;
  max-height: 500px;
}

.introduction-buttons {
  float: left;
  display: flex;
  padding-top: 30px;
  max-width: 484px;
  text-transform: none;
}
.back_button {
  border: 1px solid #bcccdc;
  box-sizing: border-box;
  border-radius: 14px;
}
.email-btn {
  border: 1px solid #bcccdc;
  box-sizing: border-box;
  border-radius: 5px;
  font-weight: 300;
}

.like-btn {
  border: 1px solid #bcccdc;
  box-sizing: border-box;
  border-radius: 5px;
  font-weight: 300;
}

.image-displayer {
  margin-top: 10px;
  width: 100%;
  height: 50%;
  display: flex;
  position: relative;
}

.article {
  margin: 5%;
}

.article * {
  display: block;
}
.title {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
}

.subtitle {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
}

.cost {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
}

.buttons {
  margin-top: 2em;
}

.buttons .v-btn {
  margin-top: 10px;
}

.button {
  border: 1px solid #102a43;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100% !important;
}

@media screen and (min-width: 1264px) {
  .button {
    width: 70% !important;
  }
}

.contact-button {
  background: #102a43;
  color: white;
}

.box-article {
  padding: 2% 5%;
  margin: 8% 0%;
  border: 1px solid #bcccdc;
  box-sizing: border-box;
  border-radius: 14px;
  background-color: white;
}

.usage {
  padding: 12px 0;
}

.usage * {
  display: block;
}

.usage-title {
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 20px !important;
  line-height: 24px !important;
}

.usage-text {
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 15px !important;
  line-height: 24px !important;
}

.box-article .title {
  font-size: 16px !important;
}
</style>
